import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "./../../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService, PurchaseOrderService } from "./../../../services/index";
@Component({
  selector: "addEditInvoice",
  templateUrl: "./addRackallocation.html",
})
export class addRackallocation {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  whList: any = [];
  // nameList = ["1","2" ,"3","4","5","6","7","8"];

  codeList: any;
  seasonList: any;
  rackList: any;
  lineList: any;
  nameList: any;
  bayList: any;

  execApi: boolean = true;
  //  isEdit: boolean = false;
  invoicedata: any = {};
  delPartyList: any;
  party_id: any;
  box: any;
  result: any;
  desData: any = {
    total: 0
  };
  designList: any;
  invalidList: any = [];
  colorList: any = [];
  qualityList: any = [];
  fabColorlist: any = [];
  fabColorTemplist: any = [];

  mode: string;
  saveEvent: any;
  agentList: any;
  uniqueTypeList: any;
  prefixList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  isShow: boolean = false;

  sampleList = [{ name: "YES" }, { name: "NO" }];

  partyList: any = [];
  varietyList = ["CHECKS", "PLAIN"];
  widthList = ["36", "44", "58"];
  styleList = ["FORMAL", "CASUAL", "RR FORMAL", "RR CASUAL", "DAMAGE", "OLIVE", "OTHER BRANDS", "SPECIAL GOODS"];
  typeList = ["SET", "SIZE"];
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  upd_type: any;
  res = []
  listSelected = [];
  validRack: boolean = false;
  isLoadMask: Promise<any>;
  @Input() _params: any;
  qualitylist: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
   let invoicedata = Object.assign({}, val["data"]);
    this.invoicedata = invoicedata;
    this.invoicedata.design_no = invoicedata.design;
    this.invoicedata.wh_code = invoicedata.warehouse;
    this.invoicedata.line_from = invoicedata.line_start;
    this.invoicedata.line_to = (invoicedata.line_start == invoicedata.line_end) ? '' : invoicedata.line_end
    this.invoicedata.rackname_from = invoicedata.rack_start;
    this.invoicedata.rackname_to =  (invoicedata.rack_start == invoicedata.rack_end) ? '' : invoicedata.rack_end 
    this.invoicedata.bayno_from = invoicedata.bay_start;
    this.invoicedata.bayno_to = (invoicedata.bay_start == invoicedata.bay_end) ? '' : invoicedata.bay_end
     this.invoicedata.availableQty = invoicedata.allocated_qty;
     this.invoicedata.totalCapacity = invoicedata.total_capacity;
     this.invoicedata.occupiedQty = invoicedata.allocated_qty;


    console.log(val)
     this.saveEvent = val["data"].tabevent;
    this.getSetDetails();
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService,
    private combo: Combo2Service,

  ) {
    this.row = {
      width: "",
      size: "",
      sleeve: "",
      type: "",

    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {

    // this.getrackName()
    this.tableScroll();
    this.invoicedata.mode = this.mode;

  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  OnselectpartyId(type) {
    let temp = this.partyList.filter(el => el.code == type);
    this.invoicedata.party_id = temp[0].party_id;


  }



  getRackStockDetails() {

    // let params = {
    //   page_type: 'Rack',
    //   whCode: this.invoicedata.wh_code   
    // }
     this.validRack = false;
    let params: any = Object.assign({}, this.invoicedata);
   
    let that = this
    that.salesinvservice.getRackStockDetails(params).then((res: any) => {
      if(res.error){
        swal("ERROR", `${res.error}!`, "error")
      }
     if(res.availableQty == 0){
        swal("ERROR", 'Rack Location Fully Occupied!!', "error")
      }
     else if (res.conflictStyles.length > 0) {
       let conflict = res.conflictStyles[0];
       let val = '';
       if (that.invoicedata.design_no && conflict.design) {
         val = conflict.design
       }
       else if (conflict.style && conflict.variety) {
         val = `${conflict.style} - ${conflict.variety}`;
       } else if (conflict.style) {
         val = conflict.style;
       } 
  
        swal("ERROR", `Rack Allocated For - ${val}!!`, "error")
      }
      else if (res.availableQty > 0) {
         that.validRack = (res.availableQty > 0) ? true : false;
         that.invoicedata.availableQty = res.availableQty;
         that.invoicedata.totalCapacity = res.totalCapacity;
         that.invoicedata.occupiedQty = res.occupiedQty;
         that.invoicedata.conflictStyles = res.conflictStyles
      }

    })

  }

  getRackDetails(type) {

    // let params = {
    //   page_type: 'Rack',
    //   whCode: this.invoicedata.wh_code   
    // }
     this.desData.total = 0;
    let params: any = Object.assign({}, this.invoicedata);
    params['type'] = type;

    let that = this
    that.salesinvservice.getRackDetails(params).then((res: any) => {
      if (res.data.length > 0) {
        if (type == 'Line') {
          that.lineList = res.data;
        }
        else if (type == 'Rack Name') {
          that.nameList = res.data;
        }
        else if (type == 'Bay No') {
          that.bayList = res.data;
        }
        that.rackList = res.List;
        that.rackList.forEach(e => {
          that.desData.total += Number(e.capacity)
        });
      }
      console.log("check Name Listtttttt", that.nameList)

    })

  }


  getrackDet() {

    let params = {
      page_type: 'Rack Allocate',
      whCode: this.invoicedata.wh_code
    }
    let that = this
    that.salesinvservice.getSetDetails(params).then((res: any) => {
      if (res.data.length > 0) {
        that.invoicedata.rackname_from = res.data[0].max_rackName;
      }


    })

  }


  getVarietyList() {

    const formalCasualStyles = ['FORMAL', 'CASUAL', 'RR FORMAL', 'RR CASUAL'];
    if(!formalCasualStyles.includes(this.invoicedata.style) && this.invoicedata.style){
      this.invoicedata.type ='SIZE';
    }
    else
    this.invoicedata.type ='';
    this.combo.varietyStylePoCombo({ style: this.invoicedata.style, page: 'Rack Allocation' }).then((res: any) => {

      let list = [...res.data];

      this.varietyList = list.reduce((unique, o) => {
        if (!unique.some(obj => obj.variety === o.variety)) {
          unique.push(o);
        }
        return unique;
      }, []);

    });

  }

  buttonStyle() {
    const style = {
      Position: "relative",
      left: this.mode == "Add" ? "90%" : "73% !important",
      bottom: "54px"
    };
    return style;
  }

  validateInputs(type): boolean {
    let errorMessage = '';

    if (!this.invoicedata.wh_code) {
      errorMessage = 'Warehouse Code is required';
      swal("ERROR", `${errorMessage}`, "error")
      return false;
    }

    else if (this.invoicedata.line_from && this.invoicedata.line_from == this.invoicedata.line_to &&this.invoicedata.line_to) {
      errorMessage = 'Select Different Line';
      swal("ERROR", `${errorMessage}`, "error")
      this.invoicedata.line_to = '';
      return false;
    }

    else if (this.invoicedata.rackname_from && this.invoicedata.rackname_from == this.invoicedata.rackname_to && this.invoicedata.rackname_to) {
      errorMessage = 'Select Different Rack Name';
      swal("ERROR", `${errorMessage}`, "error")
      this.invoicedata.rackname_to = '';
      return false;
    }

    else if (this.invoicedata.bayno_from && this.invoicedata.bayno_from == this.invoicedata.bayno_to && this.invoicedata.bayno_to) {
      errorMessage = 'Select Different Bay No';
      swal("ERROR", `${errorMessage}`, "error")
      this.invoicedata.bayno_to = '';
      return false;
    }

    this.getRackDetails(type)

  }


  loadModel(){
      $("#designpr").modal("show");
  }

  closeModel(){
         $("#designpr").modal("hide");
  }
  onEnterKeyPressed(nextEl: string) {

    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }

  }

  calcRange() {
    if (!this.invoicedata.prefix) {
      swal(`ERROR`, `Please Enter Prefix!`, `error`);
      return;
    }
    let params = {
      page_type: 'Bag',
      prefix: this.invoicedata.prefix
    }
    this.salesinvservice.getSetDetails(params).then((res: any) => {

      let List = res.data;
      // Determine next series number
      if (List.length > 0) {
        const maxSeries = Math.max(...List.map(entry => entry.series));
        this.invoicedata.from_range = maxSeries + 1;
      } else {
        this.invoicedata.from_range = 1;
      }

      // Set barcode using determined prefix and series
      this.invoicedata.barcode = `${this.invoicedata.prefix}-${this.invoicedata.from_range}`;
    })

  }




  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  getEditMode(ind) {

    this.data.invoiceList[ind].isEdit = !this.data.invoiceList[ind].isEdit;

  }

  EditDet() {

    let that = this;
    swal({
      title: "Are you sure to Clear the TableGrid?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length >= 1) {

          that.data.invoiceList = [];


        }
      },
      function (dismiss) { }
    );
  }
  getSetDetails() {
    let params = {
      page_type: 'Warehouse'
    }
    this.salesinvservice.getSetDetails(params).then((res: any) => {

      this.whList = res.data;


    });
  }
  Barcodeprint() {

    let params: any = {}
    let data = this.data.invoiceList.map(item => ({ item: 'RACK', barcode: item.location_code, whCode: item.wh_code }));
    params['data'] = JSON.stringify(data)
    console.log("check Baeforre print", params)
    this.salesinvservice.bagBarcodeprint(params).then(function (res: any) { })
  }
  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  // getAutoNumber() {

  //   this.salesinvservice.getMultiFabAuto({}).then((res: any) => {
  //     this.invoicedata.ref_no = res;
  //   });
  // }


  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }

  oncheckemptyrow(saveType) {

    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;
    // params["data"] = JSON.stringify(this.data.invoiceList);
    let that = this;

    swal({
      title: "Are you sure to save ?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.salesinvservice
        .saverackAllocationDetails(params)
        .then(function (res: any) {
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            if (saveType == 'print') {
              that.Barcodeprint();
            }
            that.isShow = false;
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          }
          else if (res.success === false && res.duplicates && res.duplicates.length > 0) {
            // Format the duplicate entries into a message string
            let duplicateMessage = "The following rack location IDs already exist:<br>";
            res.duplicates.forEach(duplicate => {
              duplicateMessage += `<b style="font-weight: bold;">- ${duplicate.location_code}</b> (Rack: <b style="font-weight: bold;">${duplicate.rack_name}</b>, Line: <b style="font-weight: bold;">${duplicate.rack_line}</b>)<br>`;
            });



            // Show the duplicate error message using SweetAlert (supporting HTML)
            swal({
              title: "ERROR",
              html: `${res.message}<br><br>${duplicateMessage}`, // Use HTML here
              type: "error"
            });
          } else if (res.success === false) {

            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });

  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/RackAllocation/addRackallocation.ts